<script>
    export let data = {};

    // components
    import Button from "./../Button.svelte";
    import CheckList from "./../CheckList.svelte";
    import DataGrid from "../composites/DataGrid.svelte";
    import DisclosureCard from "../DisclosureCard.svelte";
    import HorizontalRule from "./../presentational/HorizontalRule.svelte";
    import PurchaseProduct from "../composites/PurchaseProduct.svelte";
    import View from "../presentational/View.svelte";
    import VPNDevice from "./VPNDevice.svelte";
    import VPNLogo from "./../presentational/logos/VPNLogo.svelte";

    // functions
    import { AppData } from "../../stores.js";
    import { createEventDispatcher } from "svelte";
    import { emailVPNDownloadLinks } from "../../api/client.js";
    import { updateDevice, deleteDevice } from "../../api/client.js";
    import { processSubscription } from "../../utilities/data-wrangling.js";
    import { t } from "../../i18n";

    const { subscription, nextBillString, nextBillDate } = processSubscription(data.subscription, false, $t);
    const dispatch = createEventDispatcher();

    const vpnChecklist = {
        title: "Get Sweet VPN Stuff",
        link: {
            href: "about:blank",
            text: "Learn More",
        },
        checkItems: [
            "Impress your friends",
            "Watch US Netflix anywhere",
            "Have super secret spy-level location blocking",
            "Confuse those sneaky hackers",
            "Get peoples' approval",
        ],
    };
    const productDetails = {
        name: "AdBlock VPN",
        prices: [
            {
                amountString: "1.50",
                recurring: true,
                recurringFrequency: "monthly",
            },
            {
                amountString: "15.00",
                recurring: true,
                recurringFrequency: "yearly",
            },
        ],
        currencies: [
            {
                symbol: "$",
                text: "USD",
            },
            {
                symbol: "£",
                text: "GBP",
            },
            {
                symbol: "€",
                text: "EUR",
            },
        ],
        priceSummaryString: "$1.50 a month or $15 yearly",
    };

    const getPlatformSupported = () => true; // TODO: detect plaform :)
    $: isPlatformSupported = getPlatformSupported();
    $: isActive = data.product.status === "active";
    $: devices = Object.keys(data.product.options.devices)
        .map((key) => data.product.options.devices[key])
        .sort((a, b) => new Date(b.last) - new Date(a.last));

    const state = {
        isCancelling: false,
        isPurchasing: false,
    };
    $: isCancelling = state.isCancelling === true;
    $: isPurchasing = state.isPurchasing === true;

    const handleUpdateDevice = ({ device_id, name }) => {
        updateDevice({
            device_id,
            dataToUpdate: { name },
            onSuccess: function () {
                // TODO maybe make thie cleaner
                dispatch("message", {
                    action: "STATE_UPDATED",
                    data: {},
                });
            },
            onError: function (err) {
                console.log("update device error", err);
            },
        });
    };

    const handleDeleteDevice = ({ device_id }) => {
        deleteDevice({
            device_id,
            onSuccess: () => (devices = devices.filter((d) => d.device_id !== device_id)),
            onError: (err) => console.log("delete device error", err),
        });
    };

    const handleEmailDownloadLinks = () => {
        emailVPNDownloadLinks({
            onSuccess: function (data) {
                console.log("emailed the links", data);
            },
            onError: function (err) {
                console.log("didnt email those links oops", err);
            },
        });
    };

    const handleMessage = (msg) => {
        console.log("vpn got msg", msg);
        switch (msg.detail.action) {
            case "UPDATE":
                handleUpdateDevice(msg.detail.data);
                break;
            case "DELETE":
                handleDeleteDevice(msg.detail.data);
                break;
            default:
                console.log("default handleMessage");
                break;
        }
    };
</script>

{#if isActive}
    <DisclosureCard logoComponent="{VPNLogo}" isActive="{true}" collapsedDescription="{nextBillString}" on:message>
        <div class="row sub-data">
            <View viewType="{'card-wrap'}">
                {#if isCancelling}
                    <div class="row justify-content-space-between">
                        <h3>{$t('cancel_subscription')}</h3>
6                    </div>
                    <HorizontalRule />
                    <div class="row">
                        {$t('cancel_are_you_sure')}
                        {$t('you_will_have_access_until', {"$productName$": productDetails.name, "$nextBillDate$": nextBillDate})}.
                    </div>
                    <div class="row collapse-to-col justify-content-flex-end">
                        <Button
                            classNames="{'outline tertiary'}"
                            buttonText="{$t('no_keep_product', {"$replace$": productDetails.name})}"
                            on:click="{() => (state.isCancelling = false)}"
                        />
                        <Button
                            classNames="{'tertiary'}"
                            buttonText="{$t('yes_cancel')}"
                            on:click="{() => dispatch('message', { action: 'CANCEL_SUBSCRIPTION', data })}"
                        />
                    </div>
                    <HorizontalRule />
                {:else}
                    <div class="row justify-content-space-between">
                        <h3>{$t('subscription_for_product', {"$replace$": productDetails.name})}</h3>
                        <a href="/" on:click|preventDefault="{() => (state.isCancelling = true)}">
                            {$t('cancel_subscription')}
                        </a>
                    </div>
                    <HorizontalRule />
                    <DataGrid data="{subscription}" />
                {/if}
            </View>
        </div>

        <div class="row">
            <View viewType="{'card-wrap'}">
                <h3>{$t('active_devices')}</h3>
                {#if devices.length > 0}
                    <HorizontalRule />
                {/if}
                <div class="row collapse-to-col">
                    {#each devices as d, idx (d.id)}
                        <!-- 
                        (d.id) is a key so we can uniquely identify each item in the each block.
                        https://svelte.dev/tutorial/keyed-each-blocks -->
                        <!-- d like: { created: "2020-01-01T12:12:12.000Z", id: "did1",
                            last: "2020-01-01T12:12:12.000Z", modified: "2020-01-01T12:12:12.000Z", name: "Iain's MacBook"}
                        -->
                        {#if idx !== devices.length - 1}
                            <VPNDevice data="{d}" on:message="{handleMessage}" classNames="{'underline'}" />
                        {:else}
                            <VPNDevice data="{d}" on:message="{handleMessage}" classNames="{'underline-dark'}" />
                        {/if}
                    {/each}
                </div>
                <div class="row justify-content-flex-end">
                    {$t('number_devices_connected', {"$currentDeviceCount$": devices.length, "$maximumDeviceCount$": 6})}
                </div>
            </View>
        </div>
        <HorizontalRule />
        <div class="row align-items-center collapse-to-col justify-content-space-between">
            <div class="row align-items-center">
                <i class="material-icons-outlined">mail</i>
                <a href="/" on:click|preventDefault="{handleEmailDownloadLinks}">
                    {$t('send_download_links', {"$replace$": ($AppData.profile.emails.filter((email) => email.primary)[0] || {}).address})}
                </a>
                {#if isPlatformSupported}
                    <Button
                        buttonText="{$t('download')}"
                        classNames="{'far-right-auto'}"
                        on:click="{() => console.log('DOWNLOAD')}"
                    />
                {/if}
            </div>
        </div>
    </DisclosureCard>
{:else if isPurchasing}
    <DisclosureCard logoComponent="{VPNLogo}" isActive="{false}" isCollapsed="{false}" on:message>
        <PurchaseProduct productDetails="productDetails" />
    </DisclosureCard>
{:else}
    <DisclosureCard logoComponent="{VPNLogo}" isActive="{false}" on:message>
        <CheckList {...vpnChecklist} />
        <HorizontalRule />
        <div class="row align-items-center collapse-to-col">
            <i class="material-icons-outlined">credit_card</i>
            {productDetails.priceSummaryString}
            <Button
                buttonText="Get {productDetails.name}"
                classNames="{'far-right-auto'}"
                on:click="{() => (state.isPurchasing = true)}"
            />
        </div>
    </DisclosureCard>
{/if}

<style>
    div.sub-data {
        width: 100%;
        margin-bottom: 16px;
    }
</style>
